{
  "title": "Version des composants",
  "technicalVersion": "Version technique :",
  "components": {
    "alertManager": "Alert Manager",
    "deviceTwinManagerEsoft": "Device Twin Manager (eSoftLink)",
    "campaignManager": "Campaign Manager",
    "pkiConnector": "PKI Connector",
    "userManager": "User Manager",
    "applicationManager": "Application Manager",
    "contentManager": "Content Manager",
    "caCertificateManager": "Certificate Authority Manager",
    "certificateManager": "Certificate Manager",
    "apiGateway": "API Gateway",
    "translationManager": "Translation Manager",
    "operationManager": "Operation Manager",
    "deviceTwinManager": "Device Twin Manager",
    "licenseManager": "License Manager",
    "dataManager": "Data Manager",
    "as": "Front Application Service",
    "fi": "Front Interface",
    "lwm2mConnector": "LwM2M Connector",
    "dataEnrichment": "Data Enrichment"
  },
  "tile": {
    "version": "Version",
    "noData": "La version de ce composant n'a pas pu être récupérée.",
    "component": "Composant"
  }
}
